// Shared react-select styles tuned to match the FormShell input language
// (40px height, slate borders, indigo focus ring, indigo selected pill).
// Use as: <ReactSelect styles={nbSelectStyles} ... />
export const nbSelectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 40,
    backgroundColor: "#ffffff",
    borderRadius: 8,
    borderColor: state.isFocused
      ? "#4f46e5"
      : "rgba(15, 23, 42, 0.14)",
    boxShadow: state.isFocused
      ? "0 0 0 3px rgba(79, 70, 229, 0.16)"
      : "none",
    transition: "border-color 0.12s ease, box-shadow 0.12s ease",
    "&:hover": {
      borderColor: state.isFocused ? "#4f46e5" : "rgba(15, 23, 42, 0.22)",
    },
  }),
  valueContainer: (base) => ({ ...base, padding: "2px 8px" }),
  placeholder: (base) => ({ ...base, color: "#94a3b8", fontSize: 13.5 }),
  singleValue: (base) => ({ ...base, color: "#0f172a", fontSize: 13.5 }),
  input: (base) => ({ ...base, color: "#0f172a", margin: 0, padding: 0 }),
  indicatorSeparator: () => ({ display: "none" }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "#94a3b8",
    padding: 6,
    "&:hover": { color: "#475569" },
  }),
  clearIndicator: (base) => ({
    ...base,
    color: "#94a3b8",
    padding: 4,
    "&:hover": { color: "#dc2626" },
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: "rgba(79, 70, 229, 0.08)",
    border: "1px solid rgba(79, 70, 229, 0.18)",
    borderRadius: 999,
    overflow: "hidden",
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: "#4338ca",
    fontWeight: 500,
    fontSize: 12,
    padding: "2px 8px",
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: "#4338ca",
    "&:hover": {
      backgroundColor: "rgba(79, 70, 229, 0.18)",
      color: "#3730a3",
    },
  }),
  menu: (base) => ({
    ...base,
    borderRadius: 10,
    border: "1px solid rgba(15, 23, 42, 0.08)",
    boxShadow: "0 8px 24px -8px rgba(15, 23, 42, 0.18)",
    overflow: "hidden",
    zIndex: 50,
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  option: (base, state) => ({
    ...base,
    fontSize: 13,
    backgroundColor: state.isSelected
      ? "#4f46e5"
      : state.isFocused
      ? "rgba(79, 70, 229, 0.06)"
      : "transparent",
    color: state.isSelected ? "#ffffff" : "#0f172a",
    cursor: "pointer",
    transition: "background-color 0.1s ease",
  }),
  noOptionsMessage: (base) => ({
    ...base,
    color: "#94a3b8",
    fontSize: 12.5,
  }),
};
